import { useMutation } from 'vue-query';
import { claimFlakeService } from '@/services/claim/claim-flake.service';
import useWeb3 from '@/services/web3/useWeb3';

export default function useUserClaimsFlakeMutation() {
  // COMPOSABLES
  const { account } = useWeb3();

  // METHODS
  const queryFn = async farmPids => {
    return await claimFlakeService.getClaimFlakeStatus(account.value, farmPids);
  };

  return useMutation(queryFn);
}
